import axios from 'axios';
import { API_URL } from '@/utils/static';
import { useEffect } from 'react';
import { userActions } from '../store/user';
import { useDispatch } from 'react-redux';
import { entitiesActions } from '../store/entities';

export const api = axios.create({
  baseURL: API_URL
});

const AxiosInterceptor = ({ children }) => {
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(userActions.logout());
  };

  useEffect(() => {
    const resInterceptor = (response) => {
      return response;
    };

    const errInterceptor = (error) => {
      if (error.response.status === 401 && error?.response?.data?.message === 'INVALID_TOKEN') {
        logout();
        dispatch(entitiesActions.addToastInfo('Your authentication token has been invalidated'));
      }

      return Promise.reject(error);
    };

    const interceptor = api.interceptors.response.use(resInterceptor, errInterceptor);

    return () => api.interceptors.response.eject(interceptor);
  }, []);

  return children;
};

export { AxiosInterceptor };

export * from './investor';
export * from './auth';
export * from './admin';
export * from './kyc';
export * from './superAdmin';
